<span class="money-type">
	<span>{{ (moneyTypeKey$ | async) | translate }}</span>
</span>
<span class="session-time">
	<time>{{ sessionTime$ | async }}</time>
</span>
<span class="game-history-icon" *ngIf="gameHistoryEnabled" (click)="onShowGameHistory()">
	<i class="ico-game-history"></i>
</span>
